// extracted by mini-css-extract-plugin
export default {"component":"mE5wgH","list":"xabwVz","dropdown":"_DnpY1","price":"rV4VqY","toShopping":"omUmfm","calculateDescription":"AZP6hl"};